import RightPanel from './RightPanel.container'
export default RightPanel
